module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=FM - Federated States of Micronesia.83e49e9a.svg";